export default {
    namespaced: true,

    state:{
        loading: false,
        loaded: false
    },
    mutations: {
        startLoading(s) {
            s.loaded = false;
            s.loading = true;
        },
        finishLoading(s) {
            s.loaded = true;
        },
        stopLoading(s){
            s.loading = false;
        }
    },
}